import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-d24ebc54"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "step-one"
};
var _hoisted_2 = {
  class: "one-top"
};
var _hoisted_3 = {
  class: "video-area"
};
var _hoisted_4 = {
  class: "video-status-box"
};
var _hoisted_5 = {
  key: 0,
  class: "video-status"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "camera-close"
  }, null, -1);
});
var _hoisted_7 = {
  key: 0,
  class: "status-txt"
};
var _hoisted_8 = {
  key: 1,
  class: "status-txt"
};
var _hoisted_9 = {
  class: "micro-status"
};
var _hoisted_10 = {
  key: 0,
  class: "status-txt"
};
var _hoisted_11 = {
  key: 1,
  class: "status-txt"
};
var _hoisted_12 = {
  key: 2,
  class: "status-txt"
};
var _hoisted_13 = {
  key: 3,
  class: "status-txt"
};
var _hoisted_14 = {
  class: "device-area"
};
var _hoisted_15 = {
  class: "device-list"
};
var _hoisted_16 = {
  class: "device-item"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "浏览器", -1);
});
var _hoisted_18 = {
  key: 0,
  class: "txt"
};
var _hoisted_19 = {
  class: "device-item"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "屏幕分享", -1);
});
var _hoisted_21 = {
  key: 0,
  class: "txt"
};
var _hoisted_22 = {
  key: 1,
  class: "txt"
};
var _hoisted_23 = {
  class: "device-item"
};
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "摄像头", -1);
});
var _hoisted_25 = {
  key: 0,
  class: "txt"
};
var _hoisted_26 = {
  key: 1,
  class: "txt"
};
var _hoisted_27 = {
  class: "device-item"
};
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "麦克风", -1);
});
var _hoisted_29 = {
  key: 0,
  class: "txt"
};
var _hoisted_30 = {
  key: 1,
  class: "txt"
};
var _hoisted_31 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ");
var _hoisted_32 = ["href"];
var _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"check-tips\" data-v-d24ebc54><div class=\"tips-title\" data-v-d24ebc54><span class=\"line\" data-v-d24ebc54></span><span class=\"title\" data-v-d24ebc54>注意事项</span><span class=\"line\" data-v-d24ebc54></span></div><div class=\"row-tips\" data-v-d24ebc54><div class=\"col-tips\" data-v-d24ebc54><div class=\"col-title\" data-v-d24ebc54>1. 浏览器提示您授权，请务必点击允许；</div><div class=\"col-img img1\" data-v-d24ebc54></div></div><div class=\"col-tips\" data-v-d24ebc54><div class=\"col-title\" data-v-d24ebc54> 2. 左侧出现画面，且调试状态正常，则可进入下一步。 </div><div class=\"col-img img2\" data-v-d24ebc54></div></div></div></div>", 1);
import { computed, watch, ref, onMounted, nextTick } from 'vue';
import { EnvCheckerService } from '@/services/env/checker.service';
import { useService } from '@kaokei/use-vue-service';
import { debounce } from 'lodash-es';
import { downloadChrome } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  emits: ['update-step'],
  setup: function (__props, _a) {
    var _this = this;
    var emit = _a.emit;
    var checkerService = useService(EnvCheckerService);
    var DeviceState = computed(function () {
      return checkerService.DeviceState;
    });
    var microVideoRef = ref();
    var agreementCheck = ref(checkerService.InitCheckResult.device === 1);
    var nextStepLoading = ref(false);
    var setAgreementTips = ref(false);
    var checkCamera = function () {
      checkerService.checkVideo();
    };
    var checkMicro = function () {
      checkerService.checkAudio();
    };
    var checkScreen = function () {
      checkerService.checkScreen();
    };
    var checkStart = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              nextStepLoading.value = true;
              _a.label = 1;
            case 1:
              _a.trys.push([1, 5,, 6]);
              if (!!checkerService.checkId) return [3 /*break*/, 3];
              return [4 /*yield*/, checkerService.getStartCheckId()];
            case 2:
              _a.sent();
              _a.label = 3;
            case 3:
              return [4 /*yield*/, checkerService.checkStartDevice()];
            case 4:
              _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 6];
            case 5:
              e_1 = _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 6];
            case 6:
              return [2 /*return*/];
          }
        });
      });
    };
    var JudgeCheckSuccess = computed(checkerService.judgeSuccess);
    var onNextStep = debounce(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!DeviceState.value.hasClickChecked) return [3 /*break*/, 7];
              setAgreementTips.value = false;
              if (!agreementCheck.value) {
                _message.warning('请先同意《开启摄像头监考规则》协议', 2);
                nextTick(function () {
                  setAgreementTips.value = true;
                });
                return [2 /*return*/];
              }
              if (!JudgeCheckSuccess.value) return [3 /*break*/, 5];
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              nextStepLoading.value = true;
              // 更新检测记录
              return [4 /*yield*/, checkerService.updateCheckRecord()];
            case 2:
              // 更新检测记录
              _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 4];
            case 3:
              e_2 = _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 4];
            case 4:
              checkerService.goStep(1);
              return [3 /*break*/, 6];
            case 5:
              checkerService.NoDeviceVisible = true;
              _a.label = 6;
            case 6:
              return [3 /*break*/, 8];
            case 7:
              checkStart();
              _a.label = 8;
            case 8:
              return [2 /*return*/];
          }
        });
      });
    }, 240);
    var noAuthEntrance = function () {
      checkerService.NoDeviceVisible = true;
    };
    var showScreenTutorial = function () {
      checkerService.showScreenGuide = true;
    };
    watch(function () {
      return agreementCheck.value;
    }, function (flag) {
      if (flag) {
        setAgreementTips.value = false;
      }
    });
    onMounted(function () {
      watch(function () {
        return checkerService.stream;
      }, function (newStream) {
        if (microVideoRef.value) {
          microVideoRef.value.srcObject = newStream;
        }
      }, {
        immediate: true
      });
      // 检测是否能够第一次自动检测
      watch(function () {
        return checkerService.NeedAutoCheckDevice;
      }, function (flag) {
        if (flag) {
          onNextStep();
        }
      });
    });
    return function (_ctx, _cache) {
      var _component_a_checkbox = _resolveComponent("a-checkbox");
      var _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("video", {
        class: "video-box",
        ref: function (_value, _refs) {
          _refs['microVideoRef'] = _value;
          microVideoRef.value = _value;
        },
        autoplay: "",
        playsinline: "",
        muted: ""
      }, null, 512), !_unref(checkerService).stream ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _unref(DeviceState).camera.status === 'wait' ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 当前未接入摄像头 ")) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(DeviceState).camera.txt), 1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", {
        class: _normalizeClass(["micro-icon", [_unref(DeviceState).micro.status === 'finish' ? 'finish' : 'error']])
      }, null, 2), _unref(DeviceState).micro.status === 'process' ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 设备检测中... ")) : _unref(DeviceState).micro.status === 'error' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(DeviceState).micro.txt), 1)) : _unref(DeviceState).micro.status === 'finish' ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, "当前未接入麦克风"))])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("ul", _hoisted_15, [_createElementVNode("li", _hoisted_16, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).browser.status)]])
      }, null, 2), _hoisted_17, _unref(DeviceState).browser.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass(["txt", {
          'error-class': _unref(checkerService).browserErrMsg
        }])
      }, _toDisplayString(_unref(checkerService).browserErrMsg ? _unref(checkerService).browserErrMsg : _unref(DeviceState).browser.txt), 3)), _unref(DeviceState).browser.status === 'error' || _unref(checkerService).browserErrMsg ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "action",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return _unref(downloadChrome) && _unref(downloadChrome).apply(void 0, args);
        })
      }, " 下载谷歌浏览器 ")) : _createCommentVNode("", true)]), _createElementVNode("li", _hoisted_19, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).screen.status)]])
      }, null, 2), _hoisted_20, _unref(DeviceState).screen.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(DeviceState).screen.txt), 1)), _unref(DeviceState).screen.status === 'error' ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "action",
        onClick: checkScreen
      }, " 开启权限 ")) : _createCommentVNode("", true), _unref(DeviceState).screen.status === 'error' ? (_openBlock(), _createElementBlock("span", {
        key: 3,
        class: "action",
        onClick: showScreenTutorial
      }, " 权限教程 ")) : _createCommentVNode("", true)]), _createElementVNode("li", _hoisted_23, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).camera.status)]])
      }, null, 2), _hoisted_24, _unref(DeviceState).camera.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_25, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(DeviceState).camera.txt), 1)), _unref(DeviceState).camera.status === 'error' ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "action",
        onClick: checkCamera
      }, " 开启权限 ")) : _createCommentVNode("", true)]), _createElementVNode("li", _hoisted_27, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).micro.status)]])
      }, null, 2), _hoisted_28, _unref(DeviceState).micro.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_29, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(DeviceState).micro.txt), 1)), _unref(DeviceState).micro.status === 'error' ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "action",
        onClick: checkMicro
      }, " 开启权限 ")) : _createCommentVNode("", true)])]), _unref(checkerService).combinationResult ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["agreement", {
          'agreement-tips': setAgreementTips.value
        }])
      }, [_createVNode(_component_a_checkbox, {
        class: "agree",
        checked: agreementCheck.value,
        "onUpdate:checked": _cache[1] || (_cache[1] = function ($event) {
          return agreementCheck.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_31];
        }),
        _: 1
      }, 8, ["checked"]), _createElementVNode("a", {
        class: "agreement-link",
        target: "_blank",
        href: _unref(checkerService).combinationResult.checkAgreementUrl
      }, " 《开启摄像头监考规则》 ", 8, _hoisted_32)], 2)) : _createCommentVNode("", true), _createVNode(_component_a_button, {
        type: "primary",
        class: "next-step",
        onClick: _unref(onNextStep),
        loading: nextStepLoading.value
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(DeviceState).hasClickChecked ? '下一步' : '开始检测'), 1)];
        }),
        _: 1
      }, 8, ["onClick", "loading"]), _unref(DeviceState).hasClickChecked && !_unref(JudgeCheckSuccess) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "no-check-entry",
        onClick: noAuthEntrance
      }, " 不验证，进入考试 ")) : _createCommentVNode("", true)])]), _hoisted_33]);
    };
  }
});